import { useSession } from "@outschool/ui-auth";

type UseSubscriptionCredit = {
  hasSubscription: boolean | undefined;
  canPayWithSubscriptionCredits: boolean | undefined;
};

export default function useSubscriptionCredit(): UseSubscriptionCredit {
  const { currentUser } = useSession();

  return {
    hasSubscription: currentUser?.hasSubscription,
    canPayWithSubscriptionCredits: currentUser?.canPayWithSubscriptionCredits,
  };
}
